import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import update from "@beeldit/core/services/update";
import { useContext } from "react";
import { EventRulePriceContext } from "../contexts/EventRulePriceContext";

function useUpdate() {

  const {element, setBackendFormErrors} = useContext(EventRulePriceContext);
  const errorHandler = useErrorHandler();

  return (onSuccess: any) => {
    update('event_rule_prices', element.id, element)
      .then((response: any) => {
        onSuccess(response.data);
      })
      .catch((error: any) => {
        errorHandler(error, setBackendFormErrors)
      })
  }
}

export default useUpdate;